import { Label, TooltipDesktop, UIText1, UIText2 } from '@cian/ui-kit';
import { TColors } from '@cian/ui-kit-design-tokens/colors';
import * as React from 'react';

import * as styles from './FloatingLabel.css';

export interface IFloatingLabelProps {
  labelText: string;
  tooltipText: string;
  color: TColors;
  backgroundColor: TColors;
  tooltipTitle?: string;
  icon?: React.ReactElement;
  hasListStyle?: boolean;
  extendTooltipContent?: React.ReactElement;
  link?: string;
  linkText?: string;
  onOpen?: () => void;
}

export function FloatingLabel({
  labelText,
  tooltipText,
  tooltipTitle,
  hasListStyle = false,
  color,
  backgroundColor,
  icon,
  extendTooltipContent,
  link,
  linkText,
  onOpen,
}: IFloatingLabelProps) {
  const content = (
    <div data-name="FloatingLabel" className={styles['container']}>
      {tooltipTitle && (
        <div className={styles['title']}>
          <UIText1 fontWeight="bold">{tooltipTitle}</UIText1>
        </div>
      )}
      {hasListStyle ? (
        <ul className={styles['list']}>
          {tooltipText.split('\n').map((text, index) => (
            <li key={index}>
              <UIText2 whiteSpace={'pre-wrap'}>{text}</UIText2>
            </li>
          ))}
        </ul>
      ) : (
        <UIText2 whiteSpace="pre-wrap">{tooltipText}</UIText2>
      )}
      {link && (
        <div className={styles['link-container']}>
          <UIText2>
            <a className={styles['link']} href={link} rel="noreferrer noopener" target="_blank">
              {linkText ?? 'Как это работает'}
            </a>
          </UIText2>
        </div>
      )}
      {extendTooltipContent && <div>{extendTooltipContent}</div>}
    </div>
  );

  return (
    <TooltipDesktop title={content} theme="white" placement="bottom-start" onOpen={onOpen}>
      <span className={styles['label']}>
        <Label color={color} background={backgroundColor} icon={icon}>
          {labelText}
        </Label>
      </span>
    </TooltipDesktop>
  );
}
